import { httpHelper, config } from 'modules/common/helpers';

const BASE_URL = config.beUrl;

function getPlanProgress() {
  return httpHelper.get(`${BASE_URL}/api/progress`, {});
}

function setPlanIntroDone() {
  return httpHelper.post(`${BASE_URL}/api/introduction`, {});
}

function togglePlanStepStatus(category: string, status: number) {
  return httpHelper.put(`${BASE_URL}/api/progress`, { category, status });
}

export default { getPlanProgress, setPlanIntroDone, togglePlanStepStatus };
